// const echoURL = "admin.vinoted.servepratham.com";
const echoURL = "admin.vinoted-admin.com";
// const echoURL = "http://192.168.0.115:8000/laravel-websockets";
// const echoURL = "192.168.0.115";
export default echoURL;
